/*
 *
 * InteractiveArea actions
 *
 */

import { action } from 'typesafe-actions';

import ActionTypes from './constants';
import { Message } from 'containers/InteractiveArea/Message';

/**
 * Add a message to the intereactive area
 */
export const addMessageAction = (message: Message) =>
  action(ActionTypes.ADD_MESSAGE, { message });

export const flushMessagesAction = () => action(ActionTypes.FLUSH_MESSAGES);

export const startTutorialAction = () => action(ActionTypes.TUTORIAL);
